import { Heading } from '@dbi-tools/ui-kit';
import React from 'react';
import { connect } from 'react-redux';

import { RootState } from '../../store/root-reducer';

const StepsCounter: React.FC<{ currentStepNumber: number; totalSteps: number }> = ({
  currentStepNumber,
  totalSteps,
}) => {
  return (
    <Heading as="h4" mb={15} fontSize={{ xs: 14, md: 16 }} color="wine">
      Step {currentStepNumber} of {totalSteps}
    </Heading>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentStepNumber: state.quizState?.currentNumber,
  totalSteps: state.quizState?.totalNumber,
});

export default connect(mapStateToProps)(StepsCounter);
